export const carriers = [
    { name: "17 Post Service", value: "17postservice" },
    { name: "2ebox", value: "2ebox" },
    { name: "2GO", value: "2go" },
    { name: "360 Lion Express", value: "360lion" },
    { name: "3JMS Logistics", value: "3jmslogistics" },
    { name: "4-72 Entregando", value: "4-72" },
    { name: "4PX", value: "4px" },
    { name: "绿色国际速递", value: "6ls" },
    { name: "Best Express", value: "800bestex" },
    { name: "A1Post", value: "a1post" },
    { name: "A2B Express Logistics", value: "a2b-ba" },
    { name: "AAA Cooper", value: "aaa-cooper" },
    { name: "ABF Freight", value: "abf" },
    { name: "ABX Express", value: "abxexpress-my" },
    { name: "aCommerce", value: "acommerce" },
    { name: "ACS Courier", value: "acscourier" },
    { name: "ACS Worldwide Express", value: "acsworldwide" },
    { name: "Adicional Logistics", value: "adicional" },
    { name: "ADSOne", value: "adsone" },
    { name: "A Duie Pyle", value: "aduiepyle" },
    { name: "Mexico AeroFlash", value: "aeroflash" },
    { name: "Aeronet", value: "aeronet" },
    { name: "AEX Group", value: "aex" },
    { name: "Agility", value: "agility" },
    { name: "AIR21", value: "air21" },
    { name: "Airpak Express", value: "airpak-express" },
    { name: "Airspeed International Corporation", value: "airspeed" },
    { name: "ALLJOY SUPPLY CHAIN CO., LTD", value: "alljoy" },
    { name: "alphaFAST", value: "alphafast" },
    { name: "Always Express", value: "always-express" },
    { name: "Amazon Shipping + Amazon MCF", value: "amazon" },
    { name: "Amazon", value: "amazon-email-push" },
    { name: "Swiship UK", value: "amazon-fba-swiship" },
    { name: "Swiship DE", value: "amazon-fba-swiship-de" },
    { name: "Swiship IN", value: "amazon-fba-swiship-in" },
    { name: "Amazon order", value: "amazon-order" },
    { name: "Amazon Shipping", value: "amazon-uk-api" },
    { name: "AMS Group", value: "amsegroup" },
    { name: "An Post", value: "an-post" },
    { name: "Anicam Global", value: "anicamboxexpress" },
    { name: "Anjun", value: "anjun" },
    { name: "ANSERX", value: "anserx" },
    { name: "Anteraja", value: "anteraja" },
    { name: "AO Deutschland Ltd.", value: "ao-deutschland" },
    { name: "APC Postal Logistics", value: "apc" },
    { name: "APC Overnight", value: "apc-overnight" },
    { name: "APC Overnight Consignment Number", value: "apc-overnight-connum" },
    { name: "APG eCommerce Solutions Ltd.", value: "apg" },
    { name: "Aquiline", value: "aquiline" },
    { name: "Arco Spedizioni SP", value: "arco-spedizioni" },
    { name: "ARK Logistics", value: "ark-logistics" },
    { name: "Arrow XL", value: "arrowxl" },
    { name: "ASE KARGO", value: "ase" },
    { name: "Asendia", value: "asendia-de" },
    { name: "Asendia APAC", value: "asendia-hk" },
    { name: "Asendia UK", value: "asendia-uk" },
    { name: "Asendia USA", value: "asendia-usa" },
    { name: "ASIGNA", value: "asigna" },
    { name: "ASM(GLS Spain)", value: "asm" },
    { name: "Au Express", value: "auexpress" },
    { name: "Austrian Post (Express)", value: "austrian-post" },
    { name: "Austrian Post (Registered)", value: "austrian-post-registered" },
    { name: "Averitt Express", value: "averitt" },
    { name: "B2C Europe", value: "b2ceurope" },
    { name: "BDMnet", value: "bdmnet" },
    { name: "北俄国际", value: "be" },
    { name: "Belpost", value: "belpost" },
    { name: "Bert Transport", value: "bert-fr" },
    { name: "Best Way Parcel", value: "bestwayparcel" },
    { name: "Better Trucks", value: "bettertrucks" },
    { name: "Bulgarian Posts", value: "bgpost" },
    { name: "JP BH Pošta", value: "bh-posta" },
    { name: "BirdSystem", value: "birdsystem" },
    { name: "Blink", value: "blinklastmile" },
    { name: "Bluecare Express Ltd", value: "bluecare" },
    { name: "Blue Star", value: "bluestar" },
    { name: "Blue Express", value: "bluex" },
    { name: "Bneed", value: "bneed" },
    { name: "Bombino Express Pvt Ltd", value: "bombinoexp" },
    { name: "Bond", value: "bond" },
    { name: "Bonds Couriers", value: "bondscouriers" },
    { name: "Border Express", value: "borderexpress" },
    { name: "Boxberry", value: "box-berry" },
    { name: "BoxC", value: "boxc" },
    { name: "Bpost international", value: "bpost-international" },
    { name: "Brazil Correios", value: "brazil-correi os" },
    { name: "Bring", value: "bring" },
    { name: "Brouwer Transport en Logistiek B.V.", value: "brouwer-transport" },
    { name: "BRT Bartolini(Parcel ID)", value: "brt-it-parcelid" },
    { name: "BRT Bartolini(Sender Reference)", value: "brt-it-sender-ref" },
    { name: "CAE Delivers", value: "cae-delivers" },
    { name: "Cainiao", value: "cainiao" },
    { name: "Cambodia Post", value: "cambodia-post" },
    { name: "Canada Post", value: "canada-post" },
    { name: "Canpar Courier", value: "canpar" },
    { name: "Capital Transport", value: "capital" },
    { name: "Carriers", value: "carriers" },
    { name: "Carry-Flap Co.,Ltd.", value: "carry-flap" },
    { name: "CDEK", value: "cdek" },
    { name: "CDEK TR", value: "cdek-tr" },
    { name: "Cello Square", value: "cello-square" },
    { name: "Česká Pošta", value: "ceska-posta" },
    { name: "CEVA LOGISTICS", value: "ceva" },
    { name: "CFL Logistics", value: "cfl-logistics" },
    { name: "CGS Express", value: "cgs-express" },
    { name: "Champion Logistics", value: "champion-logistics" },
    { name: "China EMS (ePacket)", value: "china-ems" },
    { name: "China Post", value: "china-post" },
    { name: "Chit Chats", value: "chitchats" },
    { name: "Choir Express Indonesia", value: "choirexpress" },
    { name: "Chronopost Portugal(DPD)", value: "chronopost-portugal" },
    { name: "City-Link Express", value: "citylinkexpress" },
    { name: "CJ GLS", value: "cj-gls" },
    { name: "CJ Logistics International(Hong Kong)", value: "cj-hk-international" },
    { name: "CJ Korea Express", value: "cj-korea-thai" },
    { name: "CJ Century (International)", value: "cj-malaysia-international" },
    { name: "CJ Transnational Philippines", value: "cj-philippines" },
    { name: "CJ Logistics International", value: "cjlogistics" },
    { name: "CJ Packet", value: "cjpacket" },
    { name: "CL E-Logistics Solutions Limited", value: "cle-logistics" },
    { name: "Clevy Links", value: "clevy-links" },
    { name: "Cloudwish Asia", value: "cloudwish-asia" },
    { name: "CN Logistics", value: "cn-logistics" },
    { name: "ZYEX", value: "cndexpress" },
    { name: "CNE Express", value: "cnexps" },
    { name: "cnwangtong", value: "cnwangtong" },
    { name: "Colis Privé", value: "colis-prive" },
    { name: "Colissimo", value: "colissimo" },
    { name: "CollectCo", value: "collectco" },
    { name: "Collect+", value: "collectplus" },
    { name: "MDS Collivery Pty (Ltd)", value: "collivery" },
    { name: "ComOne Express", value: "com1express" },
    { name: "CometTech", value: "comet-tech" },
    { name: "Con-way Freight", value: "con-way" },
    { name: "Continental", value: "continental" },
    { name: "Copa Airlines Courier", value: "copa-courier" },
    { name: "Cope Sensitive Freight", value: "cope" },
    { name: "Correo Uruguayo", value: "correo-uy" },
    { name: "Correos de Mexico", value: "correos-de-mexico" },
    { name: "Cosmetics Now", value: "costmeticsnow" },
    { name: "Courant Plus", value: "courant-plus" },
    { name: "Urbanfox", value: "courex" },
    { name: "Courier Plus", value: "courier-plus" },
    { name: "Courier IT", value: "courierit" },
    { name: "CourierPost", value: "courierpost" },
    { name: "Couriers Please", value: "couriers-please" },
    { name: "cPacket", value: "cpacket" },
    { name: "Captain Express International", value: "cpex" },
    { name: "CRL Express", value: "crlexpress" },
    { name: "Croshot", value: "croshot" },
    { name: "CSE", value: "cse" },
    { name: "CTC Express", value: "ctc-express" },
    { name: "Cubyn", value: "cubyn" },
    { name: "Cuckoo Express", value: "cuckooexpress" },
    { name: "Cyprus Post", value: "cyprus-post" },
    { name: "Daeshin", value: "daeshin" },
    { name: "DAI Post", value: "daiglobaltrack" },
    { name: "Daiichi Freight System Inc", value: "daiichi" },
    { name: "Shanghai Aqrum Chemical Logistics Co.Ltd", value: "dajin" },
    { name: "PostNord Denmark", value: "danmark-post" },
    { name: "Danniao", value: "danniao" },
    { name: "Danske Fragtmænd", value: "danske-fragt" },
    { name: "Dawn Wing", value: "dawnwing" },
    { name: "Day & Ross", value: "dayross" },
    { name: "Dayton Freight", value: "dayton-freight" },
    { name: "DB Schenker B2B", value: "dbschenker-b2b" },
    { name: "DB Schenker", value: "dbschenker-se" },
    { name: "DB Schenker Sweden", value: "dbschenker-sv" },
    { name: "DD Express Courier", value: "ddexpress" },
    { name: "DealerSend", value: "dealer-send" },
    { name: "Deliver-iT", value: "deliver-it" },
    { name: "deliverE", value: "delivere" },
    { name: "DELIVERYONTIME LOGISTICS PVT LTD", value: "deliveryontime" },
    { name: "Deliver Your Parcel", value: "deliveryourparcel-za" },
    { name: "Delnext", value: "delnext" },
    { name: "Deltec Courier", value: "deltec-courier" },
    { name: "Innovel", value: "descartes" },
    { name: "Deutsche Post Mail", value: "deutsch-post" },
    { name: "DEX-I", value: "dex-i" },
    { name: "DHL Active Tracing", value: "dhl-active-tracing" },
    { name: "DHL Benelux", value: "dhl-benelux" },
    { name: "DHL Freight", value: "dhl-freight" },
    { name: "Deutsche Post DHL", value: "dhl-germany" },
    { name: "DHL Hong Kong", value: "dhl-hk" },
    { name: "DHL Netherlands", value: "dhl-nl" },
    { name: "DHL Express (Piece ID)", value: "dhl-pieceid" },
    { name: "DHL Poland Domestic", value: "dhl-poland" },
    { name: "DHL Supply Chain APAC", value: "dhl-supplychain-apac" },
    { name: "DHL Supply Chain Indonesia", value: "dhl-supplychain-id" },
    { name: "DHL Parcel Spain", value: "dhlparcel-es" },
    { name: "DHL Parcel NL", value: "dhlparcel-nl" },
    { name: "DHL Parcel Russia", value: "dhlparcel-ru" },
    { name: "DHL Parcel UK", value: "dhlparcel-uk" },
    { name: "Diamond Eurogistics Limited", value: "diamondcouriers" },
    { name: "GLS Logistic Systems Canada Ltd./Dicom", value: "dicom" },
    { name: "DIDADI Logistics tech", value: "didadi" },
    { name: "Dimerco Express Group", value: "dimerco" },
    { name: "Directlog", value: "directlog" },
    { name: "Direx", value: "direx" },
    { name: "DMF", value: "dmfgroup" },
    { name: "DobroPost", value: "dobropost" },
    { name: "Doora Logistics", value: "doora" },
    { name: "DPD Germany", value: "dpd-de" },
    { name: "DPD HK", value: "dpd-hk" },
    { name: "DPD Ireland", value: "dpd-ireland" },
    { name: "DPD Poland", value: "dpd-poland" },
    { name: "DPD Romania", value: "dpd-ro" },
    { name: "DPE Express", value: "dpe-express" },
    { name: "DPE South Africa", value: "dpe-za" },
    { name: "DPEX", value: "dpex" },
    { name: "DSV", value: "dsv" },
    { name: "DTD Express", value: "dtd" },
    { name: "DTDC India", value: "dtdc" },
    { name: "DTDC Australia", value: "dtdc-au" },
    { name: "DTDC Express Global PTE LTD", value: "dtdc-express" },
    { name: "DX Freight", value: "dx-freight" },
    { name: "Daylight Transport, LLC", value: "dylt" },
    { name: "Dynamic Logistics", value: "dynamic-logistics" },
    { name: "Easy Mail", value: "easy-mail" },
    { name: "Chukou1", value: "ec-firstclass" },
    { name: "Ecargo", value: "ecargo-asia" },
    { name: "ECexpress", value: "ecexpress" },
    { name: "Echo", value: "echo" },
    { name: "ECMS International Logistics Co., Ltd.", value: "ecms" },
    { name: "Ecom Express", value: "ecom-express" },
    { name: "ECOSCOOTING", value: "ecoscooting" },
    { name: "eCoutier", value: "ecoutier" },
    { name: "EFS (E-commerce Fulfillment Service)", value: "efs" },
    { name: "Ekart", value: "ekart" },
    { name: "Yilian (Elian) Supply Chain", value: "elian-post" },
    { name: "ELTA Hellenic Post", value: "elta-courier" },
    { name: "Emirates Post", value: "emirates-post" },
    { name: "EMPS Express", value: "empsexpress" },
    { name: "Endeavour Delivery", value: "endeavour-delivery" },
    { name: "Envialia", value: "envialia" },
    { name: "Envialia Reference", value: "envialia-reference" },
    { name: "eParcel Korea", value: "eparcel-kr" },
    { name: "ePost Global", value: "epostglobal" },
    { name: "Equick China", value: "equick-cn" },
    { name: "Top Ideal Express", value: "esdex" },
    { name: "Eshipping", value: "eshipping" },
    { name: "Estes", value: "estes" },
    { name: "Etomars", value: "etomars" },
    { name: "eTotal Solution Limited", value: "etotal" },
    { name: "RETS express", value: "ets-express" },
    { name: "EU Fleet Solutions", value: "eu-fleet-solutions" },
    { name: "Eurodis", value: "eurodis" },
    { name: "EWE Global Express", value: "ewe" },
    { name: "DPD France (formerly exapaq)", value: "exapaq" },
    { name: "Expeditors", value: "expeditors" },
    { name: "Expresssale", value: "expresssale" },
    { name: "FAR international", value: "far-international" },
    { name: "FarGood", value: "fargood" },
    { name: "Fastbox", value: "fastbox" },
    { name: "Fastrak Services", value: "fastrak-th" },
    { name: "Fasttrack", value: "fasttrack" },
    { name: "Fastway Ireland", value: "fastway-ireland" },
    { name: "Fastway New Zealand", value: "fastway-nz" },
    { name: "Fastway South Africa", value: "fastway-za" },
    { name: "FDSEXPRESS", value: "fdsexpress" },
    { name: "FedEx® Cross Border", value: "fedex-crossborder" },
    { name: "FedEx International MailService®", value: "fedex-fims" },
    { name: "FedEx® Freight", value: "fedex-freight" },
    { name: "FedEx® UK", value: "fedex-uk" },
    { name: "FERCAM Logistics & Transport", value: "fercam" },
    { name: "Fiege Logistics", value: "fiege" },
    { name: "Fiege Netherlands", value: "fiege-nl" },
    { name: "First Flight Couriers", value: "first-flight" },
    { name: "FirstMile", value: "firstmile" },
    { name: "Flyt Express", value: "flytexpress" },
    { name: "FMX", value: "fmx" },
    { name: "Fast & Furious", value: "fnf-za" },
    { name: "Fonsen Logistics", value: "fonsen" },
    { name: "forrun Pvt Ltd (Arpatech Venture)", value: "forrun" },
    { name: "Forward Air", value: "forwardair" },
    { name: "Freightquote by C.H. Robinson", value: "freightquote" },
    { name: "Frete Rápido", value: "freterapido" },
    { name: "Fulfilla", value: "fulfilla" },
    { name: "Fulfillmen", value: "fulfillmen" },
    { name: "Furdeco", value: "furdeco" },
    { name: "GANGBAO Supplychain", value: "gangbao" },
    { name: "GBA Services Ltd", value: "gba" },
    { name: "GBS-Broker", value: "gbs-broker" },
    { name: "GDEX", value: "gdex" },
    { name: "Geis CZ", value: "geis" },
    { name: "Gel Express Logistik", value: "gel-express" },
    { name: "GEM Worldwide", value: "gemworldwide" },
    { name: "GEODIS - Distribution & Express", value: "geodis-calberson-fr" },
    { name: "GESWL Express", value: "geswl" },
    { name: "Giao hàng nhanh", value: "ghn" },
    { name: "Tai Wan Global Business", value: "global-express" },
    { name: "GlobalTranz", value: "globaltranz" },
    { name: "Globavend", value: "globavend" },
    { name: "Globegistics Inc.", value: "globegistics" },
    { name: "GLS", value: "gls" },
    { name: "GLS Croatia", value: "gls-croatia" },
    { name: "GLS Czech Republic", value: "gls-cz" },
    { name: "GLS General Logistics Systems Slovakia s.r.o.", value: "gls-slovakia" },
    { name: "GLS Slovenia", value: "gls-slovenia" },
    { name: "Dependable Supply Chain Services", value: "godependable" },
    { name: "Global Post", value: "goglobalpost" },
    { name: "GoJavas", value: "gojavas" },
    { name: "Go Rush", value: "gorush" },
    { name: "Greyhound", value: "greyhound" },
    { name: "Grupo ampm", value: "grupoampm" },
    { name: "GSI EXPRESS", value: "gsi-express" },
    { name: "GSO(GLS-USA)", value: "gso" },
    { name: "HanJin", value: "hanjin" },
    { name: "HCT LOGISTICS CO.LTD.", value: "hct-logistics" },
    { name: "Haidaibao", value: "hdb" },
    { name: "Haidaibao (BOX)", value: "hdb-box" },
    { name: "Hellenic (Greece) Post", value: "hellenic-post" },
    { name: "Hellmann Worldwide Logistics, Inc", value: "hellmann" },
    { name: "Heppner Internationale Spedition GmbH & Co.", value: "heppner" },
    { name: "Heppner France", value: "heppner-fr" },
    { name: "Hermesworld", value: "hermes" },
    { name: "Hermes Einrichtungs Service GmbH & Co. KG", value: "hermes-2mann-handling" },
    { name: "HR Parcel", value: "hermes-it" },
    { name: "Hero Express", value: "heroexpress" },
    { name: "HFD", value: "hfd" },
    { name: "Hua Han Logistics", value: "hh-exp" },
    { name: "Hipshipper", value: "hipshipper" },
    { name: "HKD International Logistics", value: "hkd" },
    { name: "Holisol", value: "holisol" },
    { name: "Home Delivery Solutions Ltd", value: "home-delivery-solutions" },
    { name: "Hong Kong Post", value: "hong-kong-post" },
    { name: "SHENZHEN HOTSIN CARGO INT'L FORWARDING CO.,LTD", value: "hotsin-cargo" },
    { name: "Hound Express", value: "houndexpress" },
    { name: "HR Parcel", value: "hrparcel" },
    { name: "Hrvatska Pošta", value: "hrvatska-posta" },
    { name: "HSDEXPRESS", value: "hsdexpress" },
    { name: "HuanTong", value: "huantong" },
    { name: "Huodull", value: "huodull" },
    { name: "HX Express", value: "hx-express" },
    { name: "i-dika", value: "i-dika" },
    { name: "i-parcel", value: "i-parcel" },
    { name: "Beone Logistics", value: "ibeone" },
    { name: "IDEX", value: "idexpress" },
    { name: "iDexpress Indonesia", value: "idexpress-id" },
    { name: "IML", value: "iml" },
    { name: "IMX Mail", value: "imxmail" },
    { name: "India Post Domestic", value: "india-post" },
    { name: "India Post International", value: "india-post-int" },
    { name: "INDOPAKET", value: "indopaket" },
    { name: "InPost Paczkomaty", value: "inpost-paczkomaty" },
    { name: "InPost", value: "inpost-uk" },
    { name: "Intel-Valley Supply chain (ShenZhen) Co. Ltd", value: "intel-valley" },
    { name: "Intelipost (TMS for LATAM)", value: "intelipost" },
    { name: "DPD Local", value: "interlink-express" },
    { name: "DPD Local reference", value: "interlink-express-reference" },
    { name: "Interparcel Australia", value: "interparcel-au" },
    { name: "Interparcel New Zealand", value: "interparcel-nz" },
    { name: "Interparcel UK", value: "interparcel-uk" },
    { name: "INTEX Paketdienst GmbH", value: "intex-de" },
    { name: "Internet Express", value: "intexpress" },
    { name: "Israel Post", value: "israel-post" },
    { name: "Israel Post Domestic", value: "israel-post-domestic" },
    { name: "Italy SDA", value: "italy-sda" },
    { name: "J-Net", value: "j-net" },
    { name: "Jam Express", value: "jam-express" },
    { name: "Janco Ecommerce", value: "janco" },
    { name: "Janio Asia", value: "janio" },
    { name: "Japan Post", value: "japan-post" },
    { name: "Jayon Express (JEX)", value: "jayonexpress" },
    { name: "JCEX", value: "jcex" },
    { name: "JD Worldwide", value: "jd-worldwide" },
    { name: "Jersey Post", value: "jersey-post" },
    { name: "Jet-Ship Worldwide", value: "jet-ship" },
    { name: "金斗云物流", value: "jindouyun" },
    { name: "JINSUNG TRADING", value: "jinsung" },
    { name: "Jocom", value: "jocom" },
    { name: "Joom Logistics", value: "joom-logistics" },
    { name: "Joying Box", value: "joyingbox" },
    { name: "JS EXPRESS", value: "js-express" },
    { name: "J&T CARGO", value: "jtcargo" },
    { name: "J&T EXPRESS MALAYSIA", value: "jtexpress" },
    { name: "J&T Express Vietnam", value: "jtexpress-vn" },
    { name: "JX", value: "jx" },
    { name: "K1 Express", value: "k1-express" },
    { name: "Kangaroo Worldwide Express", value: "kangaroo-my" },
    { name: "KargomKolay (CargoMini)", value: "kargomkolay" },
    { name: "Kyungdong Parcel", value: "kdexp" },
    { name: "KEC", value: "kec" },
    { name: "KedaEX", value: "kedaex" },
    { name: "Kerry eCommerce", value: "kerry-ecommerce" },
    { name: "Kerry Express Thailand", value: "kerry-logistics" },
    { name: "Kerry TJ Logistics", value: "kerrytj" },
    { name: "Kerry Express (Vietnam) Co Ltd", value: "kerryttc-vn" },
    { name: "KGM Hub", value: "kgmhub" },
    { name: "Kuehne + Nagel", value: "kn" },
    { name: "Keuhne + Nagel Global", value: "kng" },
    { name: "Komon Express", value: "komon-express" },
    { name: "Korea Post EMS", value: "korea-post" },
    { name: "Korea Post", value: "kpost" },
    { name: "KURASI", value: "kurasi" },
    { name: "KWE Global", value: "kwe-global" },
    { name: "Shenzhen Jinghuada Logistics Co., Ltd", value: "kwt" },
    { name: "Kua Yue Express", value: "ky-express" },
    { name: "La Poste", value: "la-poste-colissimo" },
    { name: "Lao Post", value: "lao-post" },
    { name: "Latvijas Pasts", value: "latvijas-pasts" },
    { name: "Leader", value: "leader" },
    { name: "Legion Express", value: "legion-express" },
    { name: "LexShip", value: "lexship" },
    { name: "LHT Express", value: "lht-express" },
    { name: "LICCARDI EXPRESS COURIER", value: "liccardi-express" },
    { name: "liefery", value: "liefery" },
    { name: "Lietuvos Paštas", value: "lietuvos-pastas" },
    { name: "Line Clear Express & Logistics Sdn Bhd", value: "line" },
    { name: "Link Bridge(BeiJing)international logistics co.,ltd", value: "linkbridge" },
    { name: "Lion Parcel", value: "lion-parcel" },
    { name: "Logisters", value: "logisters" },
    { name: "Logwin Logistics", value: "logwin-logistics" },
    { name: "Lone Star Overnight", value: "lonestar" },
    { name: "Loomis Express", value: "loomis-express" },
    { name: "Lotte Global Logistics", value: "lotte" },
    { name: "佳邮国际", value: "ltianexp" },
    { name: "LTL", value: "ltl" },
    { name: "Logistic Worldwide Express", value: "lwe-hk" },
    { name: "M Xpress Sdn Bhd", value: "m-xpress" },
    { name: "M3 Logistics", value: "m3logistics" },
    { name: "MailAmericas", value: "mailamericas" },
    { name: "MailPlus", value: "mailplus" },
    { name: "MailPlus (Japan)", value: "mailplus-jp" },
    { name: "Mainfreight", value: "mainfreight" },
    { name: "Mainway", value: "mainway" },
    { name: "Malaysia Post EMS / Pos Laju", value: "malaysia-post" },
    { name: "Malaysia Post - Registered", value: "malaysia-post-posdaftar" },
    { name: "Matdespatch", value: "matdespatch" },
    { name: "Matkahuolto", value: "matkahuolto" },
    { name: "MBW Courier Inc.", value: "mbw" },
    { name: "Meest", value: "meest" },
    { name: "Mexico Redpack", value: "mexico-redpack" },
    { name: "Mexico Senda Express", value: "mexico-senda-express" },
    { name: "PT MGLOBAL LOGISTICS INDONESIA", value: "mglobal" },
    { name: "Mhi", value: "mhi" },
    { name: "Mikropakket", value: "mikropakket" },
    { name: "Mikropakket Belgium", value: "mikropakket-be" },
    { name: "Milkman", value: "milkman" },
    { name: "MISUMI Group Inc.", value: "misumi-cn" },
    { name: "Mobi Logistica", value: "mobi-br" },
    { name: "Mondial Relay", value: "mondialrelay" },
    { name: "Morelink", value: "morelink" },
    { name: "Morning Express", value: "morning-express" },
    { name: "MRW", value: "mrw-spain" },
    { name: "MUDITA", value: "mudita" },
    { name: "M&X cargo", value: "mx-cargo" },
    { name: "My DynaLogic", value: "mydynalogic" },
    { name: "NACEX", value: "nacex" },
    { name: "NACEX Spain", value: "nacex-spain" },
    { name: "NACEX Spain", value: "nacex-spain-reference" },
    { name: "Nanjing Woyuan", value: "nanjingwoyuan" },
    { name: "National Sameday", value: "national-sameday" },
    { name: "Nationwide Express", value: "nationwide-my" },
    { name: "NZ Post", value: "new-zealand-post" },
    { name: "Newegg Express", value: "neweggexpress" },
    { name: "Newgistics", value: "newgistics" },
    { name: "Newgistics API", value: "newgisticsapi" },
    { name: "New Zealand Couriers", value: "newzealand-couriers" },
    { name: "Nhans Solutions", value: "nhans-solutions" },
    { name: "Nightline", value: "nightline" },
    { name: "Nim Express", value: "nim-express" },
    { name: "NimbusPost", value: "nimbuspost" },
    { name: "Ninja Van Indonesia", value: "ninjavan-id" },
    { name: "Ninja Van Malaysia", value: "ninjavan-my" },
    { name: "Ninja Van Thailand", value: "ninjavan-thai" },
    { name: "NiPost", value: "nipost" },
    { name: "N&M Transfer Co., Inc.", value: "nmtransfer" },
    { name: "Norsk Global", value: "norsk-global" },
    { name: "Nova Poshta (International)", value: "nova-poshtaint" },
    { name: "NOX NightTimeExpress", value: "nox-night-time-express" },
    { name: "Nhat Tin Logistics", value: "ntlogistics-vn" },
    { name: "NYT SUPPLY CHAIN LOGISTICS Co.,LTD", value: "nytlogistics" },
    { name: "OCA Argentina", value: "oca-ar" },
    { name: "OCS ANA Group", value: "ocs" },
    { name: "OCS WORLDWIDE", value: "ocs-worldwide" },
    { name: "OkayParcel", value: "okayparcel" },
    { name: "Old Dominion Freight Line", value: "old-dominion" },
    { name: "Omni Parcel", value: "omniparcel" },
    { name: "One click delivery services", value: "oneclick" },
    { name: "One World Express", value: "oneworldexpress" },
    { name: "OnTrac", value: "ontrac" },
    { name: "FedEx® Poland Domestic", value: "opek" },
    { name: "Overseas Express", value: "overseas-hr" },
    { name: "PACKFLEET", value: "packfleet" },
    { name: "Packlink", value: "packlink" },
    { name: "平安达腾飞快递", value: "padtf" },
    { name: "PAL Express Limited", value: "palexpress" },
    { name: "The Pallet Network", value: "pallet-network" },
    { name: "Palletways", value: "palletways" },
    { name: "Pan-Asia International", value: "pan-asia" },
    { name: "Pandu Logistics", value: "pandulogistics" },
    { name: "Panther", value: "panther" },
    { name: "Paper Express", value: "paper-express" },
    { name: "Paquetexpress", value: "paquetexpress" },
    { name: "Parcel Force", value: "parcel-force" },
    { name: "Parcel2Go", value: "parcel2go" },
    { name: "Parcelink Logistics", value: "parcelinklogistics" },
    { name: "Parcelled.in", value: "parcelled-in" },
    { name: "PARCEL ONE", value: "parcelone" },
    { name: "ParcelPoint Pty Ltd", value: "parcelpoint" },
    { name: "Parcel Post Singapore", value: "parcelpost-sg" },
    { name: "Parcel Right", value: "parcelright" },
    { name: "Parcel To Post", value: "parceltopost" },
    { name: "CIRRO E-Commerce", value: "parcll" },
    { name: "Park N Parcel", value: "parknparcel" },
    { name: "PFC Express", value: "pfcexpress" },
    { name: "Pickrr", value: "pickrr" },
    { name: "Pickupp", value: "pickup" },
    { name: "PICK UPP", value: "pickupp-mys" },
    { name: "PICK UPP (Singapore)", value: "pickupp-sgp" },
    { name: "Pidge", value: "pidge" },
    { name: "PIL Logistics (China) Co., Ltd", value: "pil-logistics" },
    { name: "Pilot Freight Services", value: "pilot-freight" },
    { name: "Pitney Bowes", value: "pitney-bowes" },
    { name: "PITT OHIO", value: "pittohio" },
    { name: "Planzer Group", value: "planzer" },
    { name: "Poczta Polska", value: "poczta-polska" },
    { name: "Pony express", value: "pony-express" },
    { name: "Portugal CTT", value: "portugal-ctt" },
    { name: "Portugal Seur", value: "portugal-seur" },
    { name: "Pos Indonesia Domestic", value: "pos-indonesia" },
    { name: "Post Serbia", value: "post-serbia" },
    { name: "Post of Slovenia", value: "post-slovenia" },
    { name: "Post56", value: "post56" },
    { name: "Poșta Română", value: "posta-romana" },
    { name: "Posta Plus", value: "postaplus" },
    { name: "Poste Italiane", value: "poste-italiane" },
    { name: "Poste Italiane Paccocelere", value: "poste-italiane-paccocelere" },
    { name: "Posten Norge / Bring", value: "posten-norge" },
    { name: "PostNL Domestic", value: "postnl" },
    { name: "PostNL International 3S", value: "postnl-3s" },
    { name: "PostNL International", value: "postnl-international" },
    { name: "PostNord Logistics", value: "postnord" },
    { name: "Post ONE", value: "postone" },
    { name: "PostPlus", value: "postplus" },
    { name: "Iceland Post", value: "postur-is" },
    { name: "PayPal Package", value: "ppbyb" },
    { name: "Pressio", value: "pressiode" },
    { name: "Professional Couriers", value: "professional-couriers" },
    { name: "ProMed Delivery, Inc.", value: "promeddelivery" },
    { name: "PTS", value: "pts" },
    { name: "PTT Posta", value: "ptt-posta" },
    { name: "Purolator", value: "purolator" },
    { name: "Quantium", value: "quantium" },
    { name: "Qwintry Logistics", value: "qwintry" },
    { name: "Qxpress", value: "qxpress" },
    { name: "Raben Group", value: "raben-group" },
    { name: "RAF Philippines", value: "raf" },
    { name: "RaidereX", value: "raiderex" },
    { name: "RAM", value: "ramgroup-za" },
    { name: "Red Carpet Logistics", value: "rcl" },
    { name: "Redur Spain", value: "redur-es" },
    { name: "Rhenus Logistics", value: "rhenus-group" },
    { name: "Rincos", value: "rincos" },
    { name: "RL Carriers", value: "rl-carriers" },
    { name: "Roadbull Logistics", value: "roadbull" },
    { name: "Roadrunner Transport Service", value: "roadrunner-freight" },
    { name: "Rocket Parcel International", value: "rocketparcel" },
    { name: "RoyalShipments", value: "royalshipments" },
    { name: "RPD2man Deliveries", value: "rpd2man" },
    { name: "RPX Logistics", value: "rpxlogistics" },
    { name: "RPX Online", value: "rpxonline" },
    { name: "Russian Post", value: "russian-post" },
    { name: "Ruston", value: "ruston" },
    { name: "RZY Express", value: "rzyexpress" },
    { name: "Safexpress", value: "safexpress" },
    { name: "Saia LTL Freight", value: "saia-freight" },
    { name: "SAILPOST SPA", value: "sailpost" },
    { name: "SAP EXPRESS", value: "sap-express" },
    { name: "South African Post Office", value: "sapo" },
    { name: "Saudi Post", value: "saudi-post" },
    { name: "Sber Logistics", value: "sberlogistics-ru" },
    { name: "Scudex Express", value: "scudex-express" },
    { name: "闪电猴", value: "sdh-scm" },
    { name: "Southeastern Freight Lines", value: "sefl" },
    { name: "Sending Transporte Urgente y Comunicacion, S.A.U", value: "sending" },
    { name: "Sendit", value: "sendit" },
    { name: "Sendle", value: "sendle" },
    { name: "Setel Express", value: "setel" },
    { name: "SF Express China", value: "sf-express-cn" },
    { name: "SF International", value: "sfb2c" },
    { name: "SFC", value: "sfc" },
    { name: "SFC-SendfromChina", value: "sfcservice" },
    { name: "Shadowfax", value: "shadowfax" },
    { name: "Ship It Asia", value: "ship-it-asia" },
    { name: "ShipEntegra", value: "shipentegra" },
    { name: "ShipGate", value: "shipgate" },
    { name: "Shippit", value: "shippit" },
    { name: "Shiprocket X", value: "shiprocket" },
    { name: "SHIPTER", value: "shipter" },
    { name: "Westgate Global", value: "shipwestgate" },
    { name: "ShopfansRU LLC", value: "shopfans" },
    { name: "Olive", value: "shopolive" },
    { name: "SENHONG INTERNATIONAL LOGISTICS", value: "showl" },
    { name: "Shree Maruti Courier Services Pvt Ltd", value: "shree-maruti" },
    { name: "Shree Anjani Courier", value: "shreeanjanicourier" },
    { name: "SHREE NANDAN COURIER", value: "shreenandancourier" },
    { name: "SHREE TIRUPATI COURIER SERVICES PVT. LTD.", value: "shreetirupati" },
    { name: "Shypmax", value: "shyplite" },
    { name: "J&T Express Singapore", value: "simplypost" },
    { name: "Singapore Post", value: "singapore-post" },
    { name: "Singapore Speedpost", value: "singapore-speedpost" },
    { name: "Sin Global Express", value: "singlobal-express" },
    { name: "Sinotrans", value: "sinotrans" },
    { name: "Siodemka", value: "siodemka" },
    { name: "Slovenská pošta, a.s.", value: "sk-posta" },
    { name: "SkyPostal", value: "sky-postal" },
    { name: "SKYBOX", value: "skybox" },
    { name: "SkyNet Malaysia", value: "skynet" },
    { name: "Skynet World Wide Express South Africa", value: "skynet-za" },
    { name: "SkyNet Worldwide Express", value: "skynetworldwide" },
    { name: "SkyNet Worldwide Express UAE", value: "skynetworldwide-uae" },
    { name: "Skynet Worldwide Express UK", value: "skynetworldwide-uk" },
    { name: "SMARTCAT", value: "smartcat" },
    { name: "Smooth Couriers", value: "smooth" },
    { name: "Sonic Transportation & Logistics", value: "sonictl" },
    { name: "Correos de España", value: "spain-correos-es" },
    { name: "Specialised Freight", value: "specialisedfreight-za" },
    { name: "Speed Couriers", value: "speedcouriers-gr" },
    { name: "Spee-Dee Delivery", value: "speedee" },
    { name: "SPEEDEX", value: "speedex" },
    { name: "SPOTON Logistics Pvt Ltd", value: "spoton" },
    { name: "Spring GDS", value: "spring-gds" },
    { name: "SPRINT PACK", value: "sprint-pack" },
    { name: "Shopee Express", value: "spx" },
    { name: "Shopee Xpress", value: "spx-th" },
    { name: "SRE Korea", value: "srekorea" },
    { name: "SRT Transport", value: "srt-transport" },
    { name: "Stallion Express", value: "stallionexpress" },
    { name: "Star Track Courier", value: "star-track-courier" },
    { name: "Star Track Express", value: "star-track-express" },
    { name: "STARKEN", value: "starken" },
    { name: "Stat Overnight", value: "statovernight" },
    { name: "STEP FORWARD FREIGHT SERVICE CO LTD", value: "stepforwardfs" },
    { name: "STO Express", value: "sto" },
    { name: "STONE3PL", value: "stone3pl" },
    { name: "Streck Transport", value: "streck-transport" },
    { name: "Sutton Transport", value: "sutton" },
    { name: "PostNord Sweden", value: "sweden-posten" },
    { name: "Swiship", value: "swiship" },
    { name: "Sunyou Post", value: "sypost" },
    { name: "DPEX China", value: "szdpex" },
    { name: "SZENDEX", value: "szendex" },
    { name: "Taiwan Post", value: "taiwan-post" },
    { name: "TAQBIN Hong Kong", value: "taqbin-hk" },
    { name: "Yamato Japan", value: "taqbin-jp" },
    { name: "PRESIDENT TRANSNET CORP", value: "taqbin-taiwan" },
    { name: "TONDA GLOBAL", value: "tarrive" },
    { name: "Geniki Taxydromiki", value: "taxydromiki" },
    { name: "Tazmanian Freight Systems", value: "tazmanian-freight" },
    { name: "TCK Express", value: "tck-express" },
    { name: "Testing Courier", value: "testing-courier" },
    { name: "TFM Xpress", value: "tfm" },
    { name: "TForce Final Mile", value: "tforce-finalmile" },
    { name: "Kerry Express Hong Kong", value: "tgx" },
    { name: "Thabit Logistics", value: "thabit-logistics" },
    { name: "Thailand Thai Post", value: "thailand-post" },
    { name: "TP Logistic", value: "thaiparcels" },
    { name: "The Courier Guy", value: "thecourierguy" },
    { name: "TDG – The Delivery Group", value: "thedeliverygroup" },
    { name: "TIG Freight", value: "tigfreight" },
    { name: "Tiki", value: "tiki" },
    { name: "TNT", value: "tnt" },
    { name: "TNT Australia", value: "tnt-au" },
    { name: "TNT-Click Italy", value: "tnt-click" },
    { name: "TNT France", value: "tnt-fr" },
    { name: "TNT Italy", value: "tnt-it" },
    { name: "TNT Reference", value: "tnt-reference" },
    { name: "TNT UK", value: "tnt-uk" },
    { name: "TNT UK Reference", value: "tnt-uk-reference" },
    { name: "Toll IPEC", value: "toll-ipec" },
    { name: "Toll New Zealand", value: "toll-nz" },
    { name: "Team Global Express", value: "toll-priority" },
    { name: "Tolos", value: "tolos" },
    { name: "Tophatter Express", value: "tophatterexpress" },
    { name: "TopYou", value: "topyou" },
    { name: "CTT Express", value: "tourline" },
    { name: "Trackon Couriers Pvt. Ltd", value: "trackon" },
    { name: "P2P TrakPak", value: "trakpak" },
    { name: "Trans Kargo Internasional", value: "trans-kargo" },
    { name: "Trans2u", value: "trans2u" },
    { name: "TransMission", value: "transmission-nl" },
    { name: "TRUMPCARD LLC", value: "trumpcard" },
    { name: "Tuffnells Parcels Express", value: "tuffnells" },
    { name: "Tuffnells Parcels Express- Reference", value: "tuffnells-reference" },
    { name: "UBI Smart Parcel", value: "ubi-logistics" },
    { name: "ucexpress", value: "uc56" },
    { name: "UCS", value: "ucs" },
    { name: "United Delivery Service", value: "uds" },
    { name: "UK Mail", value: "uk-mail" },
    { name: "UkrPoshta", value: "ukrposhta" },
    { name: "UPS Freight", value: "ups-freight" },
    { name: "UPS Mail Innovations", value: "ups-mi" },
    { name: "UPS Reference", value: "ups-reference" },
    { name: "USF Reddaway", value: "usf-reddaway" },
    { name: "uShip", value: "uship" },
    { name: "Venipak", value: "venipak" },
    { name: "ViaEurope", value: "viaeurope" },
    { name: "ViettelPost", value: "viettelpost" },
    { name: "VIWO IoT", value: "viwo" },
    { name: "VicTas Freight Express", value: "vtfe" },
    { name: "Wahana", value: "wahana" },
    { name: "WanbExpress", value: "wanbexpress" },
    { name: "Weaship", value: "weaship" },
    { name: "WeDo Logistics", value: "wedo" },
    { name: "WePost Sdn Bhd", value: "wepost" },
    { name: "We World Express", value: "weworldexpress" },
    { name: "Whistl", value: "whistl" },
    { name: "万邑通", value: "winit" },
    { name: "Wise Express", value: "wise-express" },
    { name: "Wiseloads", value: "wiseloads" },
    { name: "WishPost", value: "wishpost" },
    { name: "Wizmo", value: "wizmo" },
    { name: "wnDirect", value: "wndirect" },
    { name: "Worldnet Logistics", value: "worldnet" },
    { name: "XDP Express", value: "xdp-uk" },
    { name: "XDP Express Reference", value: "xdp-uk-reference" },
    { name: "XL Express", value: "xl-express" },
    { name: "Xpert Delivery", value: "xpert-delivery" },
    { name: "XPO", value: "xpo-logistics" },
    { name: "Xpost.ph", value: "xpost" },
    { name: "XpressBees", value: "xpressbees" },
    { name: "Xpressen", value: "xpressen-dk" },
    { name: "XQ Express", value: "xq-express" },
    { name: "Xingyunyi Logistics", value: "xyy" },
    { name: "Yakit", value: "yakit" },
    { name: "Yanwen", value: "yanwen" },
    { name: "Shenzhen 1st International Logistics(Group)Co,Ltd", value: "ydex" },
    { name: "YDH express", value: "ydh-express" },
    { name: "YiFan Express", value: "yifan" },
    { name: "英诺供应链", value: "yingnuo-logistics" },
    { name: "Yodel International", value: "yodel-international" },
    { name: "Yodel Direct", value: "yodeldirect" },
    { name: "YRC", value: "yrc" },
    { name: "YTO Express", value: "yto" },
    { name: "Yunda Express", value: "yundaex" },
    { name: "YunExpress", value: "yunexpress" },
    { name: "Yurtici Kargo", value: "yurtici-kargo" },
    { name: "HUAHANG EXPRESS", value: "yycom" },
    { name: "YYEXPRESS", value: "yyexpress" },
    { name: "Zajil Express Company", value: "zajil-express" },
    { name: "Zeleris", value: "zeleris" },
    { name: "Eshun international Logistic", value: "zes-express" },
    { name: "Ziing", value: "ziingfinalmile" },
    { name: "Zinc", value: "zinc" },
    { name: "ZJS International", value: "zjs-express" },
    { name: "ZTO Express China", value: "zto-domestic" },
    { name: "ZTO Express Global", value: "zto-express" },
    { name: "DMSMatrix", value: "dms-matrix" },
    { name: "Go People", value: "gopeople" },
    { name: "HUBBED", value: "hubbed" },
    { name: "Panther Order Number", value: "panther-order-number" },
    { name: "Sims Global", value: "simsglobal" },
    { name: "Transport Ambientales", value: "tanet" },
    { name: "Georgian Post", value: "gpost" },
    { name: "GO Logistics & Storage", value: "gols" },
    { name: "Luwjistik", value: "luwjistik" },
    { name: "U-ENVIOS", value: "u-envios" },
    { name: "BUFFALO", value: "buffalo" },
    { name: "ACI Logistix", value: "acilogistix" },
    { name: "Morning Global", value: "morninglobal" },
    { name: "FRONTdoor Collective", value: "frontdoorcorp" },
    { name: "TransVirtual", value: "transvirtual" },
    { name: "Quiet Platforms", value: "airterra" },
    { name: "Burd Delivery Aps", value: "burd" },
    { name: "Pandion", value: "pandion" },
    { name: "TYP", value: "typ" },
    { name: "ICS COURIER", value: "icscourier" },
    { name: "ShunBang Express", value: "shunbang-express" },
    { name: "ViaXpress", value: "viaxpress" },
    { name: "XGS", value: "xgs" },
    { name: "uParcel", value: "uparcel" },
    { name: "Tomydoor", value: "tomydoor" },
    { name: "Plycon Transportation Group", value: "plycongroup" },
    { name: "FlipXpress", value: "flipxp" },
    { name: "Northline", value: "northline" },
    { name: "Crossflight Limited", value: "crossflight" },
    { name: "Ozeparts Shipping", value: "ozeparts-shipping" },
    { name: "QTrack", value: "qtrack" },
    { name: "Fast Despatch Logistics Limited", value: "fastdespatch" },
    { name: "Fastship Express", value: "fastship" },
    { name: "Optima Courier", value: "optimacourier" },
    { name: "FUJIE EXPRESS", value: "fujexp" },
    { name: "iThink Logistics", value: "ithinklogistics" },
    { name: "Cago", value: "cago" },
    { name: "Eco Freight", value: "ecofreight" },
    { name: "Tusk Logistics", value: "tusklogistics" },
    { name: "EMS", value: "ems" },
    { name: "DeliverDirect", value: "smartkargo" },
    { name: "Servientrega", value: "servientrega" },
    { name: "Trusk France", value: "trusk" },
    { name: "INTERSMARTTRANS & SOLUTIONS SL", value: "intersmarttrans" },
    { name: "J&T Express Philippines", value: "jtexpress-ph" },
    { name: "Movianto", value: "movianto" },
    { name: "Thunder Express Australia", value: "thunderexpress" },
    { name: "Flight Logistics Group", value: "flightlg" },
    { name: "SHIPXPRESS", value: "shipxpres" },
    { name: "ADS Express", value: "ads" },
    { name: "Big Smart", value: "bigsmart" },
    { name: "Med Africa Logistics", value: "medafrica" },
    { name: "Packeta", value: "packeta" },
    { name: "Pakajo World", value: "pakajo" },
    { name: "Sppedaf Express", value: "speedaf" },
    { name: "Cacesa", value: "cacesa" },
    { name: "Asyad Express", value: "asyadexpress" },
    { name: "EasyRoutes", value: "easyroutes" },
    { name: "EXPRESSONE", value: "expressone" },
    { name: "GC Express", value: "gcx" },
    { name: "ZYEX", value: "zyou" },
    { name: "TDN", value: "tdn" },
    { name: "Early Bird", value: "earlybird" },
    { name: "Swiship JP", value: "swiship-jp" },
    { name: "Bringer Parcel Services", value: "bringer" },
    { name: "SpeedX", value: "speedx" },
    { name: "SkyExpress Internationals", value: "skyexpressinternational" },
    { name: "Swiss Universal Express", value: "swiss-universal-express" },
    { name: "Associate Global Systems", value: "agsystems" },
    { name: "American West", value: "awest" },
    { name: "Ninjavan Vietnam", value: "ninjavan-vn" },
    { name: "Braun's Express", value: "braunsexpress" },
    { name: "Castle Parcels", value: "castleparcels" },
    { name: "Spedisci.online", value: "spedisci" },
    { name: "DIR", value: "dirmensajeria" },
    { name: "AICS", value: "arihantcourier" },
    { name: "SkyExpress Internationals", value: "skyexpress-international" },
    { name: "Super Pac Line", value: "superpackline" },
    { name: "DOMINO", value: "domino" },
    { name: "GLS USA", value: "gls-us" },
    { name: "Paikeda", value: "paikeda" },
    { name: "LogoiX", value: "logoix" },
    { name: "ups-checker", value: "ups-checker" },
    { name: "RPM", value: "rpm" },
    { name: "EXPRESSONE", value: "expressone-sv" },
    { name: "Urb-it", value: "urb-it" },
    { name: "Go Bolt", value: "gobolt" },
    { name: "hepsiJET", value: "hepsijet" },
    { name: "Grand Slam Express", value: "grandslamexpress" },
    { name: "LIEFERGRUN", value: "liefergrun" },
    { name: "SG LINK", value: "sglink" },
    { name: "Packaly", value: "packaly" },
    { name: "pack-man", value: "pack-man" },
    { name: "eShipper", value: "eshipper" },
    { name: "Multientrega", value: "multientregapanama" },
    { name: "Welivery", value: "welivery" },
    { name: "准时达跨境", value: "jusdasr" },
    { name: "GLS Romania", value: "gls-romania" },
    { name: "Urbify", value: "urbify" },
    { name: "eTower", value: "etower" },
    { name: "GTA GSM", value: "gtagsm" },
    { name: "Yunant", value: "yunant" },
    { name: "Sky King", value: "skyking" },
    { name: "Maergo", value: "maergo" },
    { name: "Transpak Inc.", value: "transpak" },
    { name: "Aoyue", value: "aoyue" },
    { name: "shopline", value: "shopline" },
    { name: "Easyparcel", value: "easyparcel" },
    { name: "Team Express Service LLC", value: "teamexpressllc" },
    { name: "Kinisi Transport Pty Ltd", value: "kinisi" },
    { name: "Navlungo", value: "navlungo" },
    { name: "LM Parcel", value: "lmparcel" },
    { name: "Sendy Express", value: "sendy" },
    { name: "Discount Post", value: "emega" },
    { name: "Jawar", value: "jawar" },
    { name: "FleetOptics", value: "fleetopticsinc" },
    { name: "ShipGlobal", value: "shipglobal-us" },
    { name: "Southwestern Motor Transport. Inc", value: "smtl" },
    { name: "ATA", value: "ata" },
    { name: "Madrooex", value: "madrooex" },
    { name: "Yunhuipost", value: "yunhuipost" },
    { name: "Oakh Harbour Freight Lines", value: "oakh" },
    { name: "Zoom", value: "zoom-red" },
    { name: "PIGGYSHIP", value: "piggyship" },
    { name: "Go For GPS", value: "goforgps" },
    { name: "DPD Portugal", value: "dpd-prt" },
    { name: "Barsan Global Lojistik", value: "barsan" },
    { name: "Asendia Global", value: "asendia" },
    { name: "Kolay Gelsin", value: "kolay-gelsin" },
    { name: "MNG Kargo", value: "mng-kargo" },
    { name: "PTT Kargo", value: "ptt-kargo" },
    { name: "Scotty", value: "scotty" },
    { name: "Pack-Up", value: "pack-up" },
    { name: "Surat Kargo", value: "surat-kargo" },
    { name: "Sendeo Kargo", value: "sendeo-kargo" },
    { name: "OTS", value: "otschile" },
    { name: "Leman", value: "leman" },
    { name: "xmszm", value: "xmszm" },
    { name: "YouParcel", value: "youparcel" },
    { name: "Xindus", value: "xindus" },
    { name: "Moovin", value: "moovin" },
    { name: "Rivo", value: "air-canada-global" },
    { name: "Allied Express", value: "alliedexpress" },
    { name: "Grupo logistico Andreani", value: "andreani" },
    { name: "AO Logistics", value: "ao-courier" },
    { name: "Aramex", value: "aramex" },
    { name: "ATS Healthcare", value: "atshealthcare" },
    { name: "Australia Post", value: "australia-post" },
    { name: "Jitsu", value: "jitsu" },
    { name: "BJS Distribution, Storage & Couriers", value: "bjshomedelivery" },
    { name: "Bluedart", value: "bluedart" },
    { name: "Bollore Logistics", value: "bollore-logistics" },
    { name: "Bpost", value: "bpost" },
    { name: "BRT Bartolini", value: "brt-it" },
    { name: "CBL Logistica", value: "cbl-logistica" },
    { name: "Chronopost France", value: "chronopost-france" },
    { name: "Coordinadora", value: "coordinadora" },
    { name: "Correos Express", value: "correosexpress" },
    { name: "DACHSER", value: "dachser" },
    { name: "Delhivery", value: "delhivery" },
    { name: "Destiny Transportation", value: "destiny" },
    { name: "Detrack", value: "detrack" },
    { name: "DHL Express", value: "dhl" },
    { name: "DHL Spain Domestic", value: "dhl-es" },
    { name: "DHL eCommerce Solutions", value: "dhl-global-mail" },
    { name: "DHL eCommerce Asia", value: "dhl-global-mail-asia" },
    { name: "DHL Supply Chain Australia", value: "dhl-supply-chain-au" },
    { name: "Dialogo Logistica", value: "dialogo-logistica" },
    { name: "Direct Couriers", value: "directcouriers" },
    { name: "DPD", value: "dpd" },
    { name: "DPD Hungary", value: "dpd-hungary" },
    { name: "DPD Russia", value: "dpd-ru" },
    { name: "DPD UK", value: "dpd-uk" },
    { name: "DX", value: "dx" },
    { name: "Estafeta", value: "estafeta" },
    { name: "Aramex Australia", value: "fastway-au" },
    { name: "FedEx®", value: "fedex" },
    { name: "Flash Express", value: "flashexpress" },
    { name: "Gati-KWE", value: "gati-kwe" },
    { name: "Go Express and logistics", value: "general-overnight" },
    { name: "GIO Express Inc", value: "gio-ecourier" },
    { name: "GLS Italy", value: "gls-italy" },
    { name: "GLS Netherlands", value: "gls-netherlands" },
    { name: "Helthjem", value: "helthjem" },
    { name: "Hermes Germany", value: "hermes-de" },
    { name: "Hunter Express", value: "hunter-express" },
    { name: "iCumulus", value: "icumulus" },
    { name: "International Seur", value: "international-seur" },
    { name: "JNE", value: "jne" },
    { name: "Kronos Express", value: "kronos" },
    { name: "Lalamove", value: "lalamove" },
    { name: "Lalamove Plus", value: "lalamove-plus" },
    { name: "Lalamove Plus - Must Connect", value: "lalamove-plus-api" },
    { name: "Landmark Global", value: "landmark-global" },
    { name: "LaserShip", value: "lasership" },
    { name: "Malca-Amit", value: "malca-amit" },
    { name: "EVRi", value: "myhermes-uk" },
    { name: "Nationex", value: "nationex" },
    { name: "Ninja Van", value: "ninjavan" },
    { name: "Nippon Express", value: "nippon-express" },
    { name: "Nova Poshta", value: "nova-poshta" },
    { name: "Innight Express Germany GmbH (nox NachtExpress)", value: "nox-nachtexpress" },
    { name: "Omniva", value: "omniva" },
    { name: "Orange Connex", value: "orangeconnex" },
    { name: "OrangeDS (Orange Distribution Solutions Inc)", value: "orangedsinc" },
    { name: "OSM Worldwide", value: "osm-worldwide" },
    { name: "Panther Reference", value: "panther-reference" },
    { name: "PFL", value: "pflogistics" },
    { name: "Posti", value: "posti" },
    { name: "Royal Mail", value: "royal-mail" },
    { name: "Sagawa", value: "sagawa" },
    { name: "Seino", value: "seino" },
    { name: "SEKO Logistics", value: "sekologistics" },
    { name: "SF Express", value: "sf-express" },
    { name: "ShipStation", value: "shipstation" },
    { name: "Sicepat Ekspres", value: "sicepat-ekspres" },
    { name: "SmartFreight", value: "smartfreight" },
    { name: "Starshipit", value: "starshipit" },
    { name: "Stuart", value: "stuart" },
    { name: "Vesyl", value: "vesyl" }
]
